module.exports = __webpack_public_path__ + "static/img/service2.ea2ed82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/service2.jpg
// module id = Qxly
// module chunks = 9